export default {
	id: null, // current user's chat id
	firebase: null,
}
